import React from 'react';
import { Sparkles, Bell } from 'lucide-react';

const UpcomingSalon: React.FC = () => {
  return (
    <section className="py-24 bg-cream px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16 space-y-6">
          <span className="inline-block px-4 py-1 bg-terracotta text-white text-[10px] font-bold uppercase tracking-[0.4em]">
            Status: In Development
          </span>
          <div className="space-y-4">
            <h3 className="text-2xl md:text-3xl font-black uppercase tracking-[0.3em] text-charcoal">The Next Resonance</h3>
            <p className="text-xl md:text-2xl font-black tracking-tight text-neutral-400">Following the success of Salon I</p>
          </div>
          <h2 className="text-4xl md:text-7xl tracking-tighter font-black text-charcoal">Spring 2026</h2>
        </div>
        
        <div className="bg-white p-10 md:p-20 rounded-2xl shadow-xl relative group overflow-hidden border border-neutral-200">
          {/* Decorative Background Element - Subtle on light bg */}
          <div className="absolute top-0 right-0 p-12 opacity-[0.03] pointer-events-none group-hover:opacity-[0.05] transition-opacity">
            <Sparkles size={160} className="text-charcoal" />
          </div>

          <div className="relative z-10 flex flex-col items-center text-center space-y-12">
            <div className="max-w-2xl space-y-8">
              <div className="flex justify-center mb-4">
                 <div className="w-16 h-px bg-terracotta/30" />
              </div>
              <h4 className="text-[12px] font-black uppercase tracking-[0.6em] text-terracotta">Priority Access</h4>
              <p className="text-neutral-900 text-lg md:text-2xl leading-relaxed font-bold">
                Our inaugural salon at Benedictine University reached capacity quickly. To ensure you have early access to the next invitation, join our priority list.
              </p>
              <p className="text-neutral-500 text-sm italic font-medium">
                "We don't just announce dates; we curate a community."
              </p>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-6">
              <a 
                href="#signup"
                className="group flex items-center gap-4 text-[10px] font-black uppercase tracking-[0.4em] bg-terracotta text-white px-12 py-6 rounded-full hover:bg-charcoal transition-all shadow-[0_20px_40px_-10px_rgba(192,108,93,0.3)]"
              >
                <Bell size={16} className="group-hover:animate-bounce" />
                Join the Priority List
              </a>
              <p className="text-[9px] text-neutral-400 uppercase tracking-[0.3em] font-black">
                Invitations sent 4 weeks prior to event.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpcomingSalon;